import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Link, Box, Grid, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    borderRadius: '16px',
    overflow: 'hidden',
    maxWidth: '800px',
    width: '90%',
  },
  '& .MuiDialogTitle-root': {
    backgroundColor: '#F0F7FF',
    color: '#1A237E',
    fontSize: '1.5rem',
    padding: '24px',
  },
  '& .MuiDialogContent-root': {
    padding: '32px',
    backgroundColor: '#FFFFFF',
  },
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  fontSize: '1.1rem',
  lineHeight: 1.6,
  color: '#303F9F',
}));

const HighlightedText = styled(Typography)(({ theme }) => ({
  color: '#1A237E',
  fontWeight: 'bold',
  fontSize: '2rem',
  marginBottom: theme.spacing(2),
  textAlign: 'center',
  width: '100%', // Asegura que el texto ocupe todo el ancho disponible
}));

const StyledLink = styled(Link)(() => ({
  fontSize: '1.1rem',
  fontWeight: 'bold',
  color: '#1565C0',
  '&:hover': {
    color: '#0D47A1',
  },
}));

const QRImage = styled('img')({
  width: '200px',
  height: '200px',
  margin: '0 auto',
  display: 'block',
  objectFit: 'contain',
});

const WelcomeModal = ({ open, onClose }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = () => {
    setImageError(true);
    console.error('Error al cargar la imagen del código QR');
  };

  // Nueva ruta local de la imagen
  const imagePath = '/NHZ2QF3BEBFLB1.png';

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle textAlign="center">Bienvenido al Futuro de EP - Aguas de Manta 🌊</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <HighlightedText>
              Presentamos Aqua IA 🤖💧
            </HighlightedText>
          </Grid>
          <Grid item xs={12} md={7}>
            <StyledTypography>
              Aqua IA es su nuevo asistente virtual de Inteligencia Artificial, diseñado para revolucionar la forma en que gestionamos nuestros servicios. Con capacidades avanzadas, está listo para ayudarle con:
            </StyledTypography>
            <StyledTypography>
              • Consultas de facturas 📄<br />
              • Análisis de consumos 📊<br />
              • Resolución de dudas técnicas 🔧<br />
              • Y mucho más... 🚀
            </StyledTypography>
            <StyledTypography>
              Experimente el poder de la IA en la gestión del agua. Aqua IA está aquí para hacer su trabajo más eficiente y preciso.
            </StyledTypography>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%">
              {!imageLoaded && !imageError && <CircularProgress />}
              {imageError ? (
                <Box textAlign="center">
                  <Typography color="error" gutterBottom>
                    Error al cargar la imagen. Por favor, escanee el código QR desde la aplicación de WhatsApp.
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    href="https://wa.me/message/ZDRHFUDVWRBIG1"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Abrir WhatsApp
                  </Button>
                </Box>
              ) : (
                <QRImage 
                  src={imagePath}
                  alt="Código QR para WhatsApp" 
                  onLoad={handleImageLoad}
                  onError={handleImageError}
                  style={{ display: imageLoaded ? 'block' : 'none' }}
                />
              )}
              <StyledTypography textAlign="center" mt={2}>
                Escanea el código QR para chatear con Aqua IA en WhatsApp
              </StyledTypography>
            </Box>
          </Grid>
        </Grid>
        <Box mt={3} textAlign="center">
          <StyledTypography>
            ¿Listo para el futuro? Comience ahora:
          </StyledTypography>
          <StyledLink href="https://chat.epam.gob.ec" target="_blank" rel="noopener noreferrer">
            chat.epam.gob.ec
          </StyledLink>
        </Box>
      </DialogContent>
      <DialogActions style={{ backgroundColor: '#F0F7FF', padding: '16px', justifyContent: 'center' }}>
        <Button onClick={onClose} style={{ backgroundColor: '#1A237E', color: '#FFFFFF' }} variant="contained" size="large">
          Entendido, ¡Gracias!
        </Button>
        <Button href="https://wa.me/message/NHZ2QF3BEBFLB1" target="_blank" rel="noopener noreferrer" style={{ backgroundColor: '#25D366', color: '#FFFFFF' }} variant="contained" size="large">
          Chat en WhatsApp
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

WelcomeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default WelcomeModal;